import React from 'react';
import * as _ from 'lodash';
import { ContentLayout } from '@cloudscape-design/components';

import { TextContent } from '@cloudscape-design/components';
import { useNavGraph } from 'src/components/providers/NavGraphProvider';
import { getLocaleDate } from 'src/helpers';
import { useTranslate } from 'src/i18n/useTranslate';

interface ResultFooterProps {
    attributes: Record<string, any>;
    topicUrl: string;
    lastUpdated?: Date;
}

const getStringFromDocAttributes = (
    attributes: Record<string, any>,
    key: string
): string | undefined => attributes[key]?.StringValue;

export const ResultFooter = ({
    attributes,
    lastUpdated,
}: ResultFooterProps) => {
    const { getBreadcrumbNamesFromPath } = useNavGraph();
    const t = useTranslate();

    const breadcrumbPath = getStringFromDocAttributes(
        attributes,
        'breadcrumbPath'
    );
    const breadcrumbText = breadcrumbPath
        ? getBreadcrumbNamesFromPath(breadcrumbPath).join(' > ')
        : '';

    return (
        <ContentLayout defaultPadding disableOverlap headerVariant="divider">
            <TextContent>
                <p data-list-path>
                    <small>{breadcrumbText}</small>
                </p>
            </TextContent>
            <TextContent>
                <p data-list-last-modified>
                    <small>
                        {t('details-page-last-modified', 'Last modified on')}{' '}
                        <small data-last-modified-date>
                            {lastUpdated
                                ? getLocaleDate(lastUpdated.toISOString())
                                : ''}
                        </small>
                    </small>
                </p>
            </TextContent>
        </ContentLayout>
    );
};
